import { ChangeDetectionStrategy, Component, ElementRef, Input, Renderer2 } from '@angular/core';
import { PrintCardContentComponent } from '../../shared/print-card-content.component';
import { StiiizyStrainIndexCardStackContentViewModel } from './stiiizy-strain-index-card-stack-content-view-model';
import { StiiizyStrainCardData } from '../../../../../../../models/print-cards/stiiizy-strain-card-data';

@Component({
  selector: 'app-stiiizy-strain-index-card-stack-content',
  templateUrl: './stiiizy-strain-index-card-stack-content.component.html',
  styleUrls: ['./stiiizy-strain-index-card-stack-content.component.scss'],
  providers: [StiiizyStrainIndexCardStackContentViewModel],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class StiiizyStrainIndexCardStackContentComponent extends PrintCardContentComponent {
  constructor(
    public viewModel: StiiizyStrainIndexCardStackContentViewModel,
    elementRef: ElementRef,
    renderer: Renderer2
  ) {
    super(viewModel, elementRef, renderer);
  }

  @Input() override data: StiiizyStrainCardData;
}
